import { Card, CardContent } from "@/components/ui/card"

export function CalendarCard({ children }: { children: React.ReactNode }) {
  return (
    <Card className="h-full w-full p-3">
      <CardContent
        className="h-full w-full p-0"
        style={
          {
            "--fc-today-bg-color": "transparent",
          } as React.CSSProperties
        }
      >
        {children}
      </CardContent>
    </Card>
  )
}

export function CalendarSidebarLayout({
  children,
}: {
  children: React.ReactNode
}) {
  return <div className="flex min-h-0 grow flex-row gap-4">{children}</div>
}
